import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Home, Dumbbell, TrendingUp, User } from 'lucide-react';
import { theme } from '../styles/GlobalStyles';

const BottomNavContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(30, 30, 30, 0.8);
  backdrop-filter: blur(12px);
  border-top: 1px solid var(--color-border);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: ${theme.spacing.sm} 0;
  z-index: 1000;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    display: none;
  }
`;

const NavItem = styled.button<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.xs};
  background: none;
  border: none;
  color: ${({ active }) => (active ? 'var(--color-primary)' : 'var(--color-text-muted)')};
  cursor: pointer;
  padding: ${theme.spacing.xs} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  transition: all 0.3s ease;
  font-size: ${theme.fontSize.xs};
  font-weight: ${({ active }) => (active ? theme.fontWeight.semibold : theme.fontWeight.normal)};
  font-family: 'Inter', sans-serif;
  
  &:hover {
    color: var(--color-primary);
    background: var(--color-surface-hover);
  }
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/', label: 'Início', icon: Home },
    { path: '/workout', label: 'Treino', icon: Dumbbell },
    { path: '/progress', label: 'Progresso', icon: TrendingUp },
    { path: '/profile', label: 'Perfil', icon: User },
  ];

  return (
    <BottomNavContainer>
      {navItems.map((item) => {
        const Icon = item.icon;
        return (
          <NavItem
            key={item.path}
            active={isActive(item.path)}
            onClick={() => navigate(item.path)}
            aria-label={item.label}
          >
            <Icon size={24} />
            <span>{item.label}</span>
          </NavItem>
        );
      })}
    </BottomNavContainer>
  );
};

export default BottomNav;

